let prefixed = (name) => 'sourcing_workflow/service_request/' + name

// Getters

export const PROJECT = prefixed('PROJECT')
export const TYPE_LIST = prefixed('TYPE_LIST')
export const SUB_TYPE_LIST = prefixed('SUB_TYPE_LIST')
export const STATUS_LIST = prefixed('STATUS_LIST')
export const RESOLUTION_TYPE_LIST = prefixed('RESOLUTION_TYPE_LIST')

export const TEAM_MEMBER_LIST = prefixed('TEAM_MEMBER_LIST')

export const SUBJECT_FIELD = prefixed('SUBJECT_FIELD')
export const TYPE_FIELD = prefixed('TYPE_FIELD')
export const SUB_TYPE_FIELD = prefixed('SUB_TYPE_FIELD')
export const REF_NO_FIELD = prefixed('REF_NO_FIELD')
export const STATUS_NOTE_FIELD = prefixed('STATUS_NOTE_FIELD')
export const REF_TYPE_FIELD = prefixed('REF_TYPE_FIELD')
export const BATCH_ID_FIELD = prefixed('BATCH_ID_FIELD')
export const DETAIL_FIELD = prefixed('DETAIL_FIELD')
export const ASSIGN_TO_FIELD = prefixed('ASSIGN_TO_FIELD')
export const RESOLUTION_FIELD = prefixed('RESOLUTION_FIELD')
export const RESOLUTION_TYPE_FIELD = prefixed('RESOLUTION_TYPE_FIELD')
export const ASSIGNED_DATE_FIELD = prefixed('ASSIGNED_DATE_FIELD')
export const RESOLVED_DATE_FIELD = prefixed('RESOLVED_DATE_FIELD')
export const SHIP_CANCEL_DATE_FIELD = prefixed('SHIP_CANCEL_DATE_FIELD')
export const INDC_DATE_FIELD = prefixed('INDC_DATE_FIELD')
export const COO_FIELD = prefixed('COO_FIELD')

export const DEFAULT_PRIORITY = prefixed('DEFAULT_PRIORITY')
export const DEFAULT_TRACKER = prefixed('DEFAULT_TRACKER')
export const DEFAULT_STATUS = prefixed('DEFAULT_STATUS')
export const DEFAULT_TYPE = prefixed('DEFAULT_TYPE')
export const DEFAULT_SUB_TYPE = prefixed('DEFAULT_SUB_TYPE')
export const DEFAULT_RESOLUTION_TYPE = prefixed('DEFAULT_RESOLUTION_TYPE')

export const VENDOR_NAME_FIELD = prefixed('VENDOR_NAME_FIELD')
export const VENDOR_NAME2_FIELD = prefixed('VENDOR_NAME2_FIELD')
export const VENDOR_CODE_FIELD = prefixed('VENDOR_CODE_FIELD')

export const IS_TEAM_LEADER = prefixed('IS_TEAM_LEADER')
export const IS_TEAM_MEMBER = prefixed('IS_TEAM_MEMBER')
export const IS_VENDOR = prefixed('IS_VENDOR')

export const SHAREPOINT_FOLDER_ID = prefixed('SHAREPOINT_FOLDER_ID')

export const ATTACHMENT_INFO_FIELD = prefixed('ATTACHMENT_INFO_FIELD')

export const WORKFLOW = prefixed('WORKFLOW')
export const WORKFLOW_PERMISSION = prefixed('WORKFLOW_PERMISSION')

export const BRAND_FIELD = prefixed('BRAND_FIELD')

// Mutations
export const SET_DROP_DOWN_VALUES = prefixed('SET_DROP_DOWN_VALUES')
export const SET_REDMINE_FIELDS = prefixed('SET_REDMINE_FIELDS')
export const SET_REDMINE_DEFAULT_VALUES = prefixed('SET_REDMINE_DEFAULT_VALUES')
export const SET_PROJECT = prefixed('SET_PROJECT')
export const SET_TEAM_MEMBER_LIST = prefixed('SET_TEAM_MEMBER_LIST')

// Getters & Mutations
export const DROP_DOWN_VALUES_RETRIEVED = prefixed('DROP_DOWN_VALUES_RETRIEVED')
export const SEARCH_RESULT_LIST = prefixed('SEARCH_RESULT_LIST')
export const SEARCH_RESULT_LIST_SELECTED = prefixed('SEARCH_RESULT_LIST_SELECTED')
export const VENDOR_NAME_TO_ID_MAP = prefixed('VENDOR_NAME_TO_ID_MAP')
export const VENDOR_ID_TO_NAME_MAP = prefixed('VENDOR_ID_TO_NAME_MAP')
export const TEAM_MEMBER_ID_TO_NAME_MAP = prefixed('TEAM_MEMBER_ID_TO_NAME_MAP')
export const TEAM_LEADER_EMAIL_MAP = prefixed('TEAM_LEADER_EMAIL_MAP')
export const SEARCH_CRITERIA = prefixed('SEARCH_CRITERIA')
export const REDMINE_ROLE_ID = prefixed('REDMINE_ROLE_ID')
export const CUSTOM_FIELD_VISIBILITIES = prefixed('CUSTOM_FIELD_VISIBILITIES')
export const VENDOR_LIST = prefixed('VENDOR_LIST')

// Actions
export const FETCH_DROP_DOWN_VALUES = prefixed('FETCH_DROP_DOWN_VALUES')
export const RETRIEVE_PROJECT = prefixed('RETRIEVE_PROJECT')
export const GET_SHAREPOINT_FOLDER_ID = prefixed('GET_SHAREPOINT_FOLDER_ID')
export const GET_WORKFLOW = prefixed('GET_WORKFLOW')
export const SAVE_SEARCH_CRITERIA = prefixed('SAVE_SEARCH_CRITERIA')
export const GET_VENDOR_LIST = prefixed('GET_VENDOR_LIST')



// WEBPACK FOOTER //
// ./src/components/sourcing_workflow/service_request/store/definition.js